import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import DropDown from '../../../../ui/DropDown';
import Button from "../../../../ui/Button";
import RadioButton from "../../../../ui/RadioButton";
import { toaster } from "../../../../ui/Toaster";

import { useSelector, useDispatch } from 'react-redux';
import { getDownloadExcelDocument, resetDownloadReportResponse, getDownloadPdfDocument, getDownloadthirdPartyPdfDocument } from "../../../../../store/actions/reportsAction";
import { getSubdomainList, resetSubdomainList } from "../../../../../store/actions/scanInfoAction";

const optionsExcel = [
    { label: "Asset Discovery", value: "assetDiscovery", id:"assetDiscovery" },
    { label: "Corporate Email Risk", value: "corporateEmailRisk", id:"corporateEmailRisk" },
    { label: "Concerning Exposures", value: "concerningExposure", id:"concerningExposure" },
    { label: "External Detected Vulnerabilities", value: "externalDetectedVulnerabilities", id:"externalDetectedVulnerabilities" },
    { label: "Dark Web", value: "darkWeb", id:"darkWeb" },
    { label: "Brand Insight", value: "brandInsight", id:"brandInsight" },
];

const optionsPdf = [
    { label: "Executive Summary", value: "executiveSummary", id:"executiveSummary" },
    { label: "Full Report", value: "fullReport", id:"fullreport" },
    { label: "One Time Scan Full Report", value: "oneTimeScanFullReport", id:"oneTimeScanFullReport" },
    { label: "One Time Scan Executive Summary", value: "oneTimeScanExecutiveSummary", id:"oneTimeScanExecutiveSummary" }
];

const thirdPartyPdfOptions = [
    { label: "Full Report", value: "fullReport", id:"fullreport" }
]

const DownloadReport = ({currentPageType="default", domainDetails, organizationListOption, closeDownloadReport}) => {
    
    const subdomainListResponse = useSelector((state) => state.scanInfo?.subdomainList);
    const downloadExcelReportResponse = useSelector((state) => state?.reports?.downloadExcelReport);
    const downloadPdfReportResponse = useSelector((state) => state?.reports?.downloadpdfReport);
    const downloadThirdPartyPdfResponse = useSelector((state) => state?.reports?.downloadThirdPartyPdfReport)

    const dispatch = useDispatch();
    
    const location = useLocation();
    
    const queryParams = new URLSearchParams(location.search);
    const { pathname } = location;

    const selectedCustomer = queryParams.get('customer');
    const selectedOrganization = queryParams.get('organization');
    const selectedDomain = currentPageType === "scanHistory" ? domainDetails?.domain : queryParams.get('domain');
    const selectedScanId = currentPageType === "scanHistory" ? domainDetails?.scan_id : queryParams.get('scanId');

    const [subdomainList, setSubdomainList] = useState([]);
    const [selectedSubdomain, setSelectedSubdomain] = useState("");
    const [subdomainSearch, setsubdomainSearch] = useState(""); 
    const [subdomainSearchLoading, setSubdomainSearchLoading] = useState(false);
    const [subdomainCurrentPage, setSubdomainCurrentPage] = useState(1);
    const [subdomainPageLoading, setSubdomainPageLoading] = useState(false);
    const [subdomainTotalPage, setSubdomainTotalPage] = useState(0);

    const [downloadFileOption, setDownloadFileOption] = useState("excel");
    const [selectedModuleOption, setSelectedModuleOption] = useState(optionsExcel);
    const [selectedModulePdfOption, setSelectedModulePdfoption] = useState("")

    const [pdfOptions, setPdfOptions] = useState(optionsPdf);

    const [downloadLoading, setdownloadLoading] = useState(false)
    
    const excelOptionChange = (data) => {
        setSelectedModuleOption(data)
    }

    const downloadReport = () => {
        const organization = selectedOrganization && selectedOrganization.toLowerCase() !== "all" ? `&organization_id=${selectedOrganization}` : "";
        const domain = selectedDomain && selectedDomain.toLowerCase() !== "all" ? `&domain=${selectedDomain}` : "";
        const scanId = selectedScanId && selectedScanId !== "null" ? `&scan_id=${selectedScanId}` : "";
        const subdomain = selectedSubdomain ? `&subdomain=${selectedSubdomain}` : "";
        const moduleOption = `&asset_discovery=${selectedModuleOption.some((data)=> data?.value === "assetDiscovery")}&corporate_email_risk=${selectedModuleOption.some((data)=> data?.value === "corporateEmailRisk")}&concerning_exposure=${selectedModuleOption.some((data)=> data?.value === "concerningExposure")}&external_detected_vulnerability=${selectedModuleOption.some((data)=> data?.value === "externalDetectedVulnerabilities")}&dark_web=${selectedModuleOption.some((data)=> data?.value === "darkWeb")}&brand_insight=${selectedModuleOption.some((data)=> data?.value === "brandInsight")}`;
        let reportName = ""
        if(currentPageType === "scanHistory") {
            reportName = `${selectedDomain}_full_reports.xlsx`
        } else {
            const selectedOrgName = organizationListOption.find(
                (option) => option.value === selectedOrganization
            );
            reportName = `${selectedDomain.toLowerCase() === "all" ? `${selectedOrgName.name}_full_reports.xlsx` : `${selectedDomain}_full_reports.xlsx`}`
        }
        
        if(downloadFileOption === "excel") {
            const excelUrl = `${organization}${domain}${scanId}${subdomain}${moduleOption}`;
            setdownloadLoading(true)
            dispatch(getDownloadExcelDocument(excelUrl, reportName))
        } else {
            const pdfUrl = `${domain}${scanId}`;
            setdownloadLoading(true)
            dispatch(getDownloadPdfDocument(pdfUrl, selectedDomain, selectedModulePdfOption))            
        }        
    }

    const downloadThirdPartyReport = () => {
        const customer = selectedCustomer && selectedCustomer.toLowerCase() !== "all" ? `&customer_id=${selectedCustomer}` : "";
        const organization = selectedOrganization && selectedOrganization.toLowerCase() !== "all" ? `&organization_id=${selectedOrganization}` : "";
        const domain = selectedDomain && selectedDomain.toLowerCase() !== "all" ? `&domain=${selectedDomain}` : "";
        const scanId = selectedScanId && selectedScanId !== "null" ? `&scan_id=${selectedScanId}` : "";
        const pdfUrl = `${customer}${organization}${domain}${scanId}`;
        setdownloadLoading(true)
        dispatch(getDownloadthirdPartyPdfDocument(pdfUrl, selectedDomain))        
    }

    const fetchSubDomainList = useCallback(()=>{        
        const baseUrl = `&page=${subdomainCurrentPage}&page_size=10`;
        const queryParams = subdomainSearch ? `&query=${subdomainSearch}` : "";
        const organization = selectedOrganization && selectedOrganization.toLowerCase() !== "all" ? `&organization_id=${selectedOrganization}` : '';
        const domain = selectedDomain && selectedDomain.toLowerCase() !== "all" ? `&domain=${selectedDomain}&scan_id=${selectedScanId}` : '';
        const url  = `${baseUrl}${queryParams}${organization}${domain}`
        dispatch(getSubdomainList(url))
    },[dispatch, selectedOrganization, selectedDomain, selectedScanId, subdomainSearch, subdomainCurrentPage])

    const checkButtonDisable = () => {
        if(currentPageType === "scanHistory") {
            if(downloadFileOption === "excel") {
                return selectedModuleOption.length === 0
            } else {
                return selectedModulePdfOption === ""
            }
        } else {
            if(downloadFileOption === "excel") {
                if(selectedOrganization.toLowerCase() === "all") {
                    return selectedDomain === ""
                }
                return false
            } else {
                return selectedDomain.toLowerCase() === "all" || selectedModulePdfOption === ""
            }
        }        
    }

    useEffect(()=>{        
        if(selectedDomain.toLowerCase() === "all") {
            setPdfOptions([])
            setSelectedModulePdfoption("")
        } else {
            setPdfOptions(optionsPdf)
        }
    },[selectedDomain, selectedModulePdfOption])

    useEffect(()=>{
        if(pathname.split("/")[2] === "exposure") {
            fetchSubDomainList()
        }        
    },[fetchSubDomainList, selectedDomain, selectedOrganization, pathname])

    useEffect(()=>{
        if(subdomainListResponse !== null) {
            setSubdomainSearchLoading(false)
            setSubdomainPageLoading(false)            
            
            if(subdomainListResponse?.status === "failed") {
                setSubdomainList([])
            } else {
                const list = subdomainListResponse?.results?.map((data) => ({
                    id: data.id,
                    name: data.subdomain,
                    value: data.subdomain,
                    label: data.subdomain,
                }));
                setSubdomainList((prevList) => {
                    const uniqueList = [...prevList, ...list].reduce((acc, item) => {
                        if (!acc.some(existingItem => existingItem.id === item.id)) {
                            acc.push(item);
                        }
                        return acc;
                    }, []);
                    return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
                });
                setSubdomainTotalPage(subdomainListResponse?.meta?.total_pages)
            }
            dispatch(resetSubdomainList())
        }
    },[subdomainListResponse, dispatch])

    useEffect(()=>{
        if(downloadExcelReportResponse !== null) {
            if (downloadExcelReportResponse?.status === "success") {
                toaster.addToast("Reports Downloaded successfully", "success");
                setdownloadLoading(false)
            } else if (downloadExcelReportResponse?.status === "failed") {
                toaster.addToast(downloadExcelReportResponse?.message || "Failed to Download", "error");
                setdownloadLoading(false)
            }
            closeDownloadReport()      
            dispatch(resetDownloadReportResponse())
        }
    },[downloadExcelReportResponse, dispatch, closeDownloadReport])

    useEffect(() => {
        if(downloadPdfReportResponse !== null) {
            if (downloadPdfReportResponse?.status === "success") {
                toaster.addToast("Reports Downloaded successfully", "success");
                setdownloadLoading(false)
            } else if (downloadPdfReportResponse?.status === "failed") {
                toaster.addToast(downloadPdfReportResponse?.message || "Failed to Download", "error");
                setdownloadLoading(false)
            }
            closeDownloadReport()
            dispatch(resetDownloadReportResponse())
        }
    }, [downloadPdfReportResponse, dispatch, closeDownloadReport]);

    useEffect(() => {
        if(downloadThirdPartyPdfResponse !== null) {
            if (downloadThirdPartyPdfResponse?.status === "success") {
                toaster.addToast("Reports Downloaded successfully", "success");
                setdownloadLoading(false)
            } else if (downloadThirdPartyPdfResponse?.status === "failed") {
                toaster.addToast(downloadThirdPartyPdfResponse?.message || "Failed to Download", "error");
                setdownloadLoading(false)
            }
            closeDownloadReport()
            dispatch(resetDownloadReportResponse())
        }
    }, [downloadThirdPartyPdfResponse, dispatch, closeDownloadReport]);

    return (
        <>  
            <div className="modal-header mt-4">
                <h2>Download Report</h2>
            </div>    
            <div className="add-exposure-container reports-container">
                {(pathname.split("/")[2] === "exposure" || pathname.split("/")[2] === "portfolio" || currentPageType === "scanHistory") && <Row>
                    <Col lg={12}>
                        <div className="add-organization-step-one mt-3">
                            <div className="input-container">
                                <p className="mb-1">Select Format</p>
                                <div className="d-flex gap-5 mt-3">
                                    <RadioButton radioId={"excel"} radioLabel={"Excel"} radioValue={"excel"} onChange={(data)=>setDownloadFileOption(data)} isChecked={downloadFileOption === "excel"}/>
                                    <RadioButton radioId={"pdf"} radioLabel={"PDF"} radioValue={"pdf"} onChange={(data)=>setDownloadFileOption(data)} isChecked={downloadFileOption === "pdf"}/>                                    
                                </div>                                
                            </div>
                        </div>
                    </Col>                  
                    {downloadFileOption === "excel" && <Col lg={12}>
                        <div className="add-organization-step-one mt-3">
                            <div className="input-container">
                                <p className="mb-1">Subdomain (only applicable after selecting date)</p>
                                <DropDown
                                    options={subdomainList}
                                    placeHolder="Select subdomain"
                                    onChange={(e)=>{
                                        setSelectedSubdomain(e.name)
                                    }}                                    
                                    defaultSelectedValue={selectedSubdomain}
                                    resetValue = {selectedSubdomain === "" ? true : false}
                                    dropDownType ={"reportSubdomain"}
                                    searchType={"server"}
                                    isSearchable
                                    disabled={downloadFileOption === "pdf"}
                                    updateSearchValue={(data) => {
                                        setSubdomainList([])
                                        setSubdomainSearchLoading(true)
                                        setsubdomainSearch(data)
                                        setSubdomainCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                                    }}
                                    isSearchLoading={subdomainSearchLoading}
                                    onScrollEnd = {()=>{
                                        if(!subdomainPageLoading && (subdomainTotalPage > subdomainCurrentPage)) {
                                            setSubdomainPageLoading(true)
                                            setSubdomainCurrentPage((prevPage) => prevPage + 1)
                                        }
                                    }}
                                    pageLoading={subdomainPageLoading}
                                />
                            </div>
                        </div>
                    </Col> }                   
                    {downloadFileOption === "pdf" && <Col lg={12}>
                        <div className="add-organization-step-one mt-3">
                            <div className="input-container">
                                <p className="mb-1">PDF Option</p>
                                <DropDown
                                    options={pdfOptions}
                                    placeHolder="Select Report"
                                    onChange={(data)=>{setSelectedModulePdfoption(data.value)}}
                                    selectedValue={selectedModulePdfOption}
                                    defaultSelectedValue={selectedModulePdfOption}
                                    isMulti = {false}
                                />
                            </div>
                            {selectedDomain.toLowerCase() === "all" && <p className="error-msg mt-2">Please select any Domain</p>}
                        </div>
                    </Col>}
                    {downloadFileOption === "excel" && <Col lg={12}>
                        <div className="add-organization-step-one mt-3">
                            <div className="input-container">
                                <p className="mb-1">Excel Options</p>
                                <DropDown
                                    options={optionsExcel}
                                    placeHolder="Full Report - All Modules"
                                    onChange={excelOptionChange}
                                    selectedValue={selectedModuleOption}
                                    defaultSelectedValue={selectedModuleOption}
                                    dropDownType ={"reportModule"}
                                    isMulti
                                />
                            </div>
                        </div>
                    </Col>}
                    <div className="form-submit-btn-group mt-5 d-flex align-items-right">
                        <div className="d-flex gap-3 w-100">
                        {<Button buttonType={"secondary"} buttonText={"Cancel"} buttonClicked={closeDownloadReport}/>}
                        {!downloadLoading && <Button buttonType={"primary"} buttonText={"Download Report"} buttonClicked={downloadReport} disableButton={checkButtonDisable()}/>}
                        {downloadLoading && <Button buttonType={"primary"} buttonText={"Loading..."} disableButton={true}/>}
                        </div>
                    </div>
                </Row>}
                {
                    pathname.split("/")[2] === "third-party" && 
                    <Row>
                        <Col lg={12}>
                            <div className="add-organization-step-one mt-3">
                                <div className="input-container">
                                    <p className="mb-1">PDF Option</p>
                                    <DropDown
                                        options={thirdPartyPdfOptions}
                                        placeHolder="Select Report"
                                        onChange={(data)=>{setSelectedModulePdfoption(data.value)}}
                                        selectedValue={selectedModulePdfOption}
                                        defaultSelectedValue={selectedModulePdfOption}
                                        isMulti = {false}
                                    />
                                </div>
                            </div>
                        </Col>
                        <div className="form-submit-btn-group mt-5 d-flex align-items-right">
                            <div className="d-flex gap-3 w-100">
                            {<Button buttonType={"secondary"} buttonText={"Cancel"} buttonClicked={closeDownloadReport}/>}
                            {!downloadLoading && <Button buttonType={"primary"} buttonText={"Download Report"} buttonClicked={downloadThirdPartyReport} disableButton={selectedModulePdfOption === ""}/>}
                            {downloadLoading && <Button buttonType={"primary"} buttonText={"Loading..."} disableButton={true}/>}
                            </div>
                        </div>
                    </Row>
                }
            </div>
        </>
    );
}

export default DownloadReport;
